export const formatPayrollAmount = (value) => {
  if (value === undefined || value === null || value === "") return "";

  const text = String(value).replace(/,/g, "");
  const [integer, ...decimalParts] = text.split(".");
  const groupedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return decimalParts.length
    ? `${groupedInteger}.${decimalParts.join(".")}`
    : groupedInteger;
};

export const parsePayrollAmount = (value) => {
  if (value === undefined || value === null || value === "") return "";
  return String(value).replace(/,/g, "").trim();
};

export const formatPayrollMoney = (value) =>
  `UGX ${Number(value || 0).toLocaleString("en-UG")}`;

export const payrollAmountInputProps = {
  formatter: formatPayrollAmount,
  parser: parsePayrollAmount,
};
